import { BehaviorSubject } from 'rxjs';
import { CoordinatorService } from './coordinator.service';
import { Stage, STG } from './stage';
import { Project } from './project';

const stLs: STG[] = [
    'project',
    'dashboard',
    'databin',
    'preview',
    'collection',
    'stats',
    'report',
    'book',
    'contents',
    'page',
];

export class Stage$ {
    private _stageMap = new Map<STG, Stage>();
    private _lastStage: Stage | undefined;

    private _current!: Stage;

    constructor(public coords: CoordinatorService) {
        stLs.forEach((x) => {
            const st = new Stage(this.coords, x);
            this._stageMap.set(st.tag, st);
        });
    }

    public get current(): Stage {
        return this._current;
    }

    afterProjectLoaded(isOwner: boolean, project?: Project | undefined) {
        const initStage = this._getInitStage(isOwner, project);

        const stg = this.get(initStage);
        if (stg) {
            this._current = stg;
        }
    }

    private _getInitStage(isOwner: boolean, project?: Project | undefined): STG {
        const isNew = project?.isFirstRun;
        if (isNew) return 'project';

        if (!isOwner) return 'collection';

        const hasMainItems = this.coords.dataset$.main.allXitemLs.length;
        const hasPreviewItems = this.coords.dataset$.preview.allXitemLs.length;

        if (!hasMainItems && !hasPreviewItems) return 'databin';

        return hasMainItems ? 'collection' : 'preview';
    }

    backStage() {
        this._lastStage && this.set(this._lastStage);
    }

    set(stg: STG | Stage): void {
        if (!stg) return;

        const c = this.coords.stage$.current;
        if (c && !['preview', 'collection'].includes(c.tag)) this._lastStage = c;

        if (typeof stg == 'string') stg = <Stage>this.get(stg);

        if (!stg?.isDisplayOn) stg = <Stage>this.get('collection');

        this._current = stg;
        if (stg.hasDataset) {
            this.coords.field$.stageChange();
            this.coords.filter$.stageChange();
        } else this.coords.display$.markForCheck();
    }

    get datasetTag() {
        const stg = this.coords.stage$.current;
        if (!stg) return '';
        if (stg.tag == 'collection' || stg.tag == 'report') return 'main';
        if (stg.tag == 'preview') return 'preview';
        return '';
    }

    get(tag: STG) {
        return this._stageMap.get(tag);
    }

    get isPreview() {
        return this.coords.stage$.current?.is('preview');
    }

    get isCollection() {
        return this.coords.stage$.current?.is('collection');
    }

    get isDataset() {
        return this.isPreview || this.isCollection;
    }
}
